import React, { useState, useMemo } from "react";
import Header from "../../components/header";
import Footer from "../../components/Footer";
import ConversationTile from "../../components/ConversationTile";
import ComingSoon from "../../assets/ComingSoon.webp";
import Conversation1 from "../../assets/Conversation1.svg";
import "./ConversationsPage.css";

const ConversationsPage = () => {
  // Sample conversation data with more entries to test filtering
  const allConversations = [
    {
      id: 1,
      title: "Evolution of IT Industry",
      slug: "ai-human-creativity",
      excerpt: "Coming soon...",
      image: ComingSoon,
      expertName: "Will",
      expertTitle: "Founder, GDNA",
      expertImage: Conversation1,
      expertLogo: Conversation1,
      publishDate: "2024-03-15",
      tags: ["Business", "Technology", "AWS"],
    },
  ];

  const [selectedTag, setSelectedTag] = useState("");
  const [sortBy, setSortBy] = useState("newest");

  // Get unique tags from all conversations
  const uniqueTags = useMemo(() => {
    const tagSet = new Set();
    allConversations.forEach((conversation) => {
      conversation.tags.forEach((tag) => tagSet.add(tag));
    });
    return Array.from(tagSet).sort();
  }, [allConversations]);

  // Filter and sort conversations based on selected criteria
  const filteredAndSortedConversations = useMemo(() => {
    let filtered = allConversations;

    // Apply tag filter if one is selected
    if (selectedTag) {
      filtered = filtered.filter((conversation) =>
        conversation.tags.includes(selectedTag)
      );
    }

    // Apply sorting
    return filtered.sort((a, b) => {
      const dateA = new Date(a.publishDate);
      const dateB = new Date(b.publishDate);

      switch (sortBy) {
        case "newest":
          return dateB - dateA;
        case "oldest":
          return dateA - dateB;
        default:
          return 0;
      }
    });
  }, [allConversations, selectedTag, sortBy]);

  return (
    <div className="conversations-page">
      <Header />
      <main className="conversations-container">
        <div className="conversations-header">
          <h1>Expert Conversations</h1>
          <div className="conversations-filters">
            <select
              className="filter-select"
              value={selectedTag}
              onChange={(e) => setSelectedTag(e.target.value)}
            >
              <option value="">All Topics</option>
              {uniqueTags.map((tag) => (
                <option key={tag} value={tag}>
                  {tag}
                </option>
              ))}
            </select>
            <select
              className="filter-select"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
            </select>
          </div>
        </div>
        <div className="conversations-grid">
          {filteredAndSortedConversations.map((conversation) => (
            <ConversationTile
              key={conversation.id}
              conversation={conversation}
            />
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ConversationsPage;
